import { APP_ENVIRONMENT } from '../types';
import { Capacitor } from '@capacitor/core';
import { ConfigSettingsService } from '../providers';
import { DeviceOrigin } from '../models';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, of, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslationInitializationService {
  private readonly configService = inject(ConfigSettingsService);
  private readonly environment = inject(APP_ENVIRONMENT);
  private readonly http = inject(HttpClient);
  private readonly origin = Capacitor.isNativePlatform() ? DeviceOrigin.App : DeviceOrigin.Portal;
  private readonly translate = inject(TranslateService);

  public async initializeTranslate(): Promise<void> {
    // TODO: remove this when we have a better solution for local i18n
    // ionic uses a local webserver, which is hosted on localhost :(
    if (!this.environment['production']) {
      console.log('dev environment -- using local i18n');
      this.setLanguage(await this.getLocalI18n());
      return;
    }

    const { connection } = this.configService.appSettings;
    const i18nObject = await firstValueFrom(
      this.http.get(`${connection.res}/api/file/getlocalization/${this.origin}`).pipe(
        //durch Intercetor wird httpRequest immer erfolgreich geladen, dadurch muss der undefined Status gesetzt werden
        switchMap((languageObject) => (languageObject ? of(languageObject) : this.getLocalI18n())),
      ),
    );
    this.setLanguage(i18nObject);
  }

  private async getLocalI18n(): Promise<object> {
    return await firstValueFrom(this.http.get(`./assets/i18n/de.json`));
  }

  private setLanguage(i18n: object): void {
    this.translate.setTranslation('de', i18n);
    this.translate.setDefaultLang('de');
    this.translate.use('de');
  }
}
